module.exports = __webpack_public_path__ + "4b9b53234fd3106ca097f3ce8cbd3da1.svg";